module.exports = __webpack_public_path__ + "static/media/instagram.e330e85a.svg";